/*
Notes:
	tailwind.config.js
		- There's some tailwind_test_XXX classes in main.css which references most classes to ensure none go missing;

		- Colors are defined with <alpha-value> so that opacity works
			- Ex: 'primary': 'rgb(var(--primary) / <alpha-value>)'
			- If you just use #XXXXXX values, the opacity will stay 1
		- One can export some colors from figma, but you need to do some work
			- Run plugin 'variables2css'
			- Select Mapped collection checkbox
			- Config - check that "Ignore alias" is unchecked"
			- Click Generate
			- Copy result into VSCode
				- Replace all "-default" with ""

				"border-" records
				- Replace "border-" with "" and then copy into borderColor, outlineColor and ringColor

				"text-" records
				- Move "on-color" after type so they're like "text-heading-on-color"
				- Replace "text-" with "" and copy into textColor

				"surface-" records
				- Replace "surface-" with "" and copy into backgroundColor

				"icon-" records
				- Copy into "colors" section as is

			- There are some classes added to support other colors such as borders that match a background color. You'll need to manually set these
				- These are set in main.css.tailwind_test to ensure they've been defined
				- Border/Outline/Ring
					-  'primary-darker': 'rgb(var(--primary-900) / <alpha-value>)',
				- textDecorationColor
					- 'grayscale-body': 'rgb(var(--grayscale-700) / <alpha-value>)',
				- color
					- 'icon-lo-warning-on-color': 'rgb(var(--lo-warning-200) / <alpha-value>)',// same as bg-lo-warning-on-color

	Creating Color Map:
		- Open Figma
		- In right pane click 'Plugins' tab
		- Search for variables2css and run
		- Select 'Alias' collection checkbox
		- CLick Config and check 'Ignore alias'
		- Click Generate
		- Copy the JSON into a text editor
		- Now you'll have to add "--" to the start of the names and remove the
			wrapping "rbg()"
			- Once done copy each section below

	Styles Preview:
		- You can use the following with VSCode to turn the tailwind.config.js values to HTML for the styles page:
			- This will turn it into: <tr><td class='bg-icon-accent'>icon-accent<br/>{{ getRGB('accent-450') }}</td></tr>

			Find (regex): ^(')([\w-]+)
			Replace: <tr><td class='bg-$2'>$2<br/>{{ getRGB('

			Find: ': 'rgb(var(--
			Replace:

			Find: ) / <alpha-value>)',
			Replace: ') }}</td></tr>

	rgb colors
		- three numbers, no commas between values
 */

export const themes = {

	/**
	 * Defines which theme which url will use
	 */
	'themeMap':
	{
		'127.0.0.1' : 'aian',
		'localhost' : 'comagine',

		'local.aianqio.org' : 'aian',
		'local.comagine.org' : 'comagine',
		'local.esrdnw.org' : 'esrd',
		'local.care.org' : 'care',
		'local.zoo.org' : 'zoo',

		'portal.aianqio.org' : 'aian',
		'portal.comagine.org' : 'comagine',
		'portal.esrdnw.org' : 'esrd',
		'providerportal.comagine.org' : 'care',

		'dev-portal.aianqio.org' : 'aian',
		'dev-portal.comagine.org' : 'comagine',
		'dev-portal.esrdnw.org' : 'esrd',
		'dev-providerportal.comagine.org' : 'care',
		'dev-zoo.comagine.org' : 'zoo',

		'uat-portal.aianqio.org' : 'aian',
		'uat-portal.comagine.org' : 'comagine',
		'uat-portal.esrdnw.org' : 'esrd',
		'uat-providerportal.comagine.org' : 'care',
		'uat-zoo.comagine.org' : 'zoo',

		'sit-portal.aianqio.org' : 'aian',
		'sit-portal.comagine.org' : 'comagine',
		'sit-portal.esrdnw.org' : 'esrd',
		'sit-providerportal.comagine.org' : 'care',
		'sit-zoo.comagine.org' : 'zoo',
	},

	//Theme Color Definitions
	'static': {
		/** Constants **/
		'--black': '0 0 0',
		'--white': '255 255 255'
	},

	'aian': {

		'--accent-100': '255 225 186',
		'--accent-200': '255 196 121',
		'--accent-300': '250 148 65',
		'--accent-400': '230 111 14',
		'--accent-450': '255 81 0',
		'--accent-50': '254 242 228',
		'--accent-500': '192 86 0',
		'--accent-600': '140 71 28',
		'--accent-700': '95 54 23',
		'--accent-800': '53 35 19',

		'--error-100': '251 224 208',
		'--error-200': '253 184 174',
		'--error-300': '255 141 123',
		'--error-400': '251 90 71',
		'--error-50': '255 243 242',
		'--error-500': '229 34 7',
		'--error-600': '181 9 9',
		'--error-700': '139 10 3',
		'--error-800': '92 17 17',
		'--error-900': '27 22 22',

		'--foundations-black': '0 0 0',
		'--foundations-white': '255 255 255',

		'--grayscale-100': '240 240 240',
		'--grayscale-200': '230 230 230',
		'--grayscale-300': '201 201 201',
		'--grayscale-400': '173 173 173',
		'--grayscale-50': '243 243 243',
		'--grayscale-500': '145 145 145',
		'--grayscale-600': '117 117 117',
		'--grayscale-700': '92 92 92',
		'--grayscale-800': '69 69 69',
		'--grayscale-900': '46 46 46',

		'--hi-warning-100': '255 226 209',
		'--hi-warning-200': '251 186 167',
		'--hi-warning-300': '252 144 109',
		'--hi-warning-400': '239 94 37',
		'--hi-warning-50': '253 236 221',
		'--hi-warning-500': '207 73 0',
		'--hi-warning-600': '167 47 16',
		'--hi-warning-700': '120 35 18',
		'--hi-warning-800': '61 35 29',
		'--hi-warning-900': '28 22 21',

		'--information-100': '222 229 255',
		'--information-200': '184 200 255',
		'--information-300': '148 173 255',
		'--information-400': '98 142 244',
		'--information-50': '237 240 255',
		'--information-500': '72 102 255',
		'--information-600': '62 77 237',
		'--information-700': '34 47 191',
		'--information-800': '27 43 133',
		'--information-900': '21 22 34',

		'--lo-warning-100': '255 227 150',
		'--lo-warning-200': '251 191 36',
		'--lo-warning-300': '229 160 0',
		'--lo-warning-400': '194 133 12',
		'--lo-warning-50': '254 240 200',
		'--lo-warning-500': '147 111 56',
		'--lo-warning-600': '122 89 26',
		'--lo-warning-700': '92 65 10',
		'--lo-warning-800': '59 43 21',
		'--lo-warning-900': '25 23 20',

		'--neutral-100': '225 226 234',
		'--neutral-200': '195 198 213',
		'--neutral-300': '165 170 192',
		'--neutral-400': '135 142 171',
		'--neutral-50': '240 240 244',
		'--neutral-500': '105 114 150',
		'--neutral-600': '84 91 120',
		'--neutral-700': '63 68 90',
		'--neutral-800': '42 45 60',
		'--neutral-900': '21 22 30',

		'--primary-100': '239 246 251',
		'--primary-150': '232 245 255',
		'--primary-200': '210 234 255',
		'--primary-25': '247 252 255',
		'--primary-300': '161 211 255',
		'--primary-400': '88 180 255',
		'--primary-50': '240 247 255',
		'--primary-500': '36 145 255',
		'--primary-600': '0 118 214',
		'--primary-700': '0 83 155',
		'--primary-800': '11 71 120',
		'--primary-900': '17 47 78',
		'--primary-950': '17 24 29',

		'--secondary-100': '254 230 133',
		'--secondary-200': '241 203 0',
		'--secondary-300': '221 170 1',
		'--secondary-400': '179 140 0',
		'--secondary-50': '255 245 194',
		'--secondary-500': '148 113 0',
		'--secondary-600': '119 96 23',
		'--secondary-700': '92 72 9',
		'--secondary-800': '66 45 25',

		'--success-100': '131 252 212',
		'--success-200': '12 237 166',
		'--success-300': '4 197 133',
		'--success-400': '0 168 113',
		'--success-50': '201 251 235',
		'--success-500': '0 134 89',
		'--success-600': '20 105 71',
		'--success-700': '12 78 41',
		'--success-800': '13 53 30',
		'--success-900': '13 26 18',

		'--tertiary-100': '168 242 255',
		'--tertiary-200': '82 218 242',
		'--tertiary-300': '19 181 234',
		'--tertiary-400': '0 158 193',
		'--tertiary-50': '229 250 255',
		'--tertiary-500': '0 129 161',
		'--tertiary-600': '0 104 125',
		'--tertiary-700': '14 79 92',
		'--tertiary-800': '9 59 68'
	},

	'comagine':{
		//
		'--accent-100': '237 227 255',
		'--accent-200': '213 191 255',
		'--accent-300': '195 157 235',
		'--accent-400': '173 121 233',
		'--accent-450': '130 63 206',
		'--accent-50': '247 242 255',
		'--accent-500': '147 85 220',
		'--accent-600': '120 60 185',
		'--accent-700': '84 39 143',
		'--accent-800': '57 33 94',

		'--error-100': '251 224 208',
		'--error-200': '253 184 174',
		'--error-300': '255 141 123',
		'--error-400': '251 90 71',
		'--error-50': '255 243 242',
		'--error-500': '229 34 7',
		'--error-600': '181 9 9',
		'--error-700': '139 10 3',
		'--error-800': '92 17 17',
		'--error-900': '27 22 22',

		'--foundations-black': '0 0 0',
		'--foundations-white': '255 255 255',

		'--grayscale-100': '240 240 240',
		'--grayscale-200': '230 230 230',
		'--grayscale-300': '201 201 201',
		'--grayscale-400': '173 173 173',
		'--grayscale-50': '243 243 243',
		'--grayscale-500': '145 145 145',
		'--grayscale-600': '117 117 117',
		'--grayscale-700': '92 92 92',
		'--grayscale-800': '69 69 69',
		'--grayscale-900': '46 46 46',

		'--hi-warning-100': '255 226 209',
		'--hi-warning-200': '251 186 167',
		'--hi-warning-300': '252 144 109',
		'--hi-warning-400': '239 94 37',
		'--hi-warning-50': '253 236 221',
		'--hi-warning-500': '207 73 0',
		'--hi-warning-600': '167 47 16',
		'--hi-warning-700': '120 35 18',
		'--hi-warning-800': '61 35 29',
		'--hi-warning-900': '28 22 21',

		'--information-100': '222 229 255',
		'--information-200': '184 200 255',
		'--information-300': '148 173 255',
		'--information-400': '98 142 244',
		'--information-50': '237 240 255',
		'--information-500': '72 102 255',
		'--information-600': '62 77 237',
		'--information-700': '34 47 191',
		'--information-800': '27 43 133',
		'--information-900': '21 22 34',

		'--lo-warning-100': '255 227 150',
		'--lo-warning-200': '251 191 36',
		'--lo-warning-300': '229 160 0',
		'--lo-warning-400': '194 133 12',
		'--lo-warning-50': '254 240 200',
		'--lo-warning-500': '147 111 56',
		'--lo-warning-600': '122 89 26',
		'--lo-warning-700': '92 65 10',
		'--lo-warning-800': '59 43 21',
		'--lo-warning-900': '25 23 20',

		'--neutral-100': '225 226 234',
		'--neutral-200': '195 198 213',
		'--neutral-300': '165 170 192',
		'--neutral-400': '135 142 171',
		'--neutral-50': '240 240 244',
		'--neutral-500': '105 114 150',
		'--neutral-600': '84 91 120',
		'--neutral-700': '63 68 90',
		'--neutral-800': '42 45 60',
		'--neutral-900': '21 22 30',

		'--primary-100': '231 242 245',
		'--primary-150': '225 243 248',
		'--primary-200': '195 235 250',
		'--primary-25': '245 251 255',
		'--primary-300': '151 212 234',
		'--primary-400': '130 180 201',
		'--primary-50': '240 246 250',
		'--primary-500': '40 160 203',
		'--primary-600': '13 126 162',
		'--primary-700': '45 97 125',
		'--primary-800': '34 74 88',
		'--primary-900': '20 51 61',
		'--primary-950': '15 25 28',

		'--secondary-100': '197 238 147',
		'--secondary-200': '152 208 53',
		'--secondary-300': '127 177 53',
		'--secondary-400': '113 159 42',
		'--secondary-50': '221 249 199',
		'--secondary-500': '83 130 0',
		'--secondary-600': '70 108 4',
		'--secondary-700': '47 74 11',
		'--secondary-800': '36 52 19',

		'--success-100': '131 252 212',
		'--success-200': '12 237 166',
		'--success-300': '4 197 133',
		'--success-400': '0 168 113',
		'--success-50': '201 251 235',
		'--success-500': '0 134 89',
		'--success-600': '20 105 71',
		'--success-700': '12 78 41',
		'--success-800': '13 53 30',
		'--success-900': '13 26 18',

		'--tertiary-100': '196 238 235',
		'--tertiary-200': '155 212 207',
		'--tertiary-300': '111 186 179',
		'--tertiary-400': '79 158 153',
		'--tertiary-50': '224 247 246',
		'--tertiary-500': '64 128 126',
		'--tertiary-600': '55 100 98',
		'--tertiary-700': '42 75 69',
		'--tertiary-800': '32 49 49'
	},

	'esrd': {
		'--accent-100': '237 227 255',
		'--accent-200': '213 191 255',
		'--accent-300': '195 157 235',
		'--accent-400': '173 121 233',
		'--accent-450': '130 63 206',
		'--accent-50': '247 242 255',
		'--accent-500': '147 85 220',
		'--accent-600': '120 60 185',
		'--accent-700': '84 39 143',
		'--accent-800': '57 33 94',

		'--error-100': '251 224 208',
		'--error-200': '253 184 174',
		'--error-300': '255 141 123',
		'--error-400': '251 90 71',
		'--error-50': '255 243 242',
		'--error-500': '229 34 7',
		'--error-600': '181 9 9',
		'--error-700': '139 10 3',
		'--error-800': '92 17 17',
		'--error-900': '27 22 22',

		'--foundations-black': '0 0 0',
		'--foundations-white': '255 255 255',

		'--grayscale-100': '240 240 240',
		'--grayscale-200': '230 230 230',
		'--grayscale-300': '201 201 201',
		'--grayscale-400': '173 173 173',
		'--grayscale-50': '243 243 243',
		'--grayscale-500': '145 145 145',
		'--grayscale-600': '117 117 117',
		'--grayscale-700': '92 92 92',
		'--grayscale-800': '69 69 69',
		'--grayscale-900': '46 46 46',

		'--hi-warning-100': '255 226 209',
		'--hi-warning-200': '251 186 167',
		'--hi-warning-300': '252 144 109',
		'--hi-warning-400': '239 94 37',
		'--hi-warning-50': '253 236 221',
		'--hi-warning-500': '207 73 0',
		'--hi-warning-600': '167 47 16',
		'--hi-warning-700': '120 35 18',
		'--hi-warning-800': '61 35 29',
		'--hi-warning-900': '28 22 21',

		'--information-100': '222 229 255',
		'--information-200': '184 200 255',
		'--information-300': '148 173 255',
		'--information-400': '98 142 244',
		'--information-50': '237 240 255',
		'--information-500': '72 102 255',
		'--information-600': '62 77 237',
		'--information-700': '34 47 191',
		'--information-800': '27 43 133',
		'--information-900': '21 22 34',

		'--lo-warning-100': '255 227 150',
		'--lo-warning-200': '251 191 36',
		'--lo-warning-300': '229 160 0',
		'--lo-warning-400': '194 133 12',
		'--lo-warning-50': '254 240 200',
		'--lo-warning-500': '147 111 56',
		'--lo-warning-600': '122 89 26',
		'--lo-warning-700': '92 65 10',
		'--lo-warning-800': '59 43 21',
		'--lo-warning-900': '25 23 20',

		'--neutral-100': '225 226 234',
		'--neutral-200': '195 198 213',
		'--neutral-300': '165 170 192',
		'--neutral-400': '135 142 171',
		'--neutral-50': '240 240 244',
		'--neutral-500': '105 114 150',
		'--neutral-600': '84 91 120',
		'--neutral-700': '63 68 90',
		'--neutral-800': '42 45 60',
		'--neutral-900': '21 22 30',

		'--primary-100': '231 242 245',
		'--primary-150': '225 243 248',
		'--primary-200': '195 235 250',
		'--primary-25': '245 251 255',
		'--primary-300': '151 212 234',
		'--primary-400': '130 180 201',
		'--primary-50': '240 246 250',
		'--primary-500': '40 160 203',
		'--primary-600': '13 126 162',
		'--primary-700': '45 97 125',
		'--primary-800': '34 74 88',
		'--primary-900': '20 51 61',
		'--primary-950': '15 25 28',

		'--secondary-100': '197 238 147',
		'--secondary-200': '152 208 53',
		'--secondary-300': '127 177 53',
		'--secondary-400': '113 159 42',
		'--secondary-50': '221 249 199',
		'--secondary-500': '83 130 0',
		'--secondary-600': '70 108 4',
		'--secondary-700': '47 74 11',
		'--secondary-800': '36 52 19',

		'--success-100': '131 252 212',
		'--success-200': '12 237 166',
		'--success-300': '4 197 133',
		'--success-400': '0 168 113',
		'--success-50': '201 251 235',
		'--success-500': '0 134 89',
		'--success-600': '20 105 71',
		'--success-700': '12 78 41',
		'--success-800': '13 53 30',
		'--success-900': '13 26 18',

		'--tertiary-100': '196 238 235',
		'--tertiary-200': '155 212 207',
		'--tertiary-300': '111 186 179',
		'--tertiary-400': '79 158 153',
		'--tertiary-50': '224 247 246',
		'--tertiary-500': '64 128 126',
		'--tertiary-600': '55 100 98',
		'--tertiary-700': '42 75 69',
		'--tertiary-800': '32 49 49'
	},

	'care':{
		//
		'--accent-100': '237 227 255',
		'--accent-200': '213 191 255',
		'--accent-300': '195 157 235',
		'--accent-400': '173 121 233',
		'--accent-450': '130 63 206',
		'--accent-50': '247 242 255',
		'--accent-500': '147 85 220',
		'--accent-600': '120 60 185',
		'--accent-700': '84 39 143',
		'--accent-800': '57 33 94',

		'--error-100': '251 224 208',
		'--error-200': '253 184 174',
		'--error-300': '255 141 123',
		'--error-400': '251 90 71',
		'--error-50': '255 243 242',
		'--error-500': '229 34 7',
		'--error-600': '181 9 9',
		'--error-700': '139 10 3',
		'--error-800': '92 17 17',
		'--error-900': '27 22 22',

		'--foundations-black': '0 0 0',
		'--foundations-white': '255 255 255',

		'--grayscale-100': '240 240 240',
		'--grayscale-200': '230 230 230',
		'--grayscale-300': '201 201 201',
		'--grayscale-400': '173 173 173',
		'--grayscale-50': '243 243 243',
		'--grayscale-500': '145 145 145',
		'--grayscale-600': '117 117 117',
		'--grayscale-700': '92 92 92',
		'--grayscale-800': '69 69 69',
		'--grayscale-900': '46 46 46',

		'--hi-warning-100': '255 226 209',
		'--hi-warning-200': '251 186 167',
		'--hi-warning-300': '252 144 109',
		'--hi-warning-400': '239 94 37',
		'--hi-warning-50': '253 236 221',
		'--hi-warning-500': '207 73 0',
		'--hi-warning-600': '167 47 16',
		'--hi-warning-700': '120 35 18',
		'--hi-warning-800': '61 35 29',
		'--hi-warning-900': '28 22 21',

		'--information-100': '222 229 255',
		'--information-200': '184 200 255',
		'--information-300': '148 173 255',
		'--information-400': '98 142 244',
		'--information-50': '237 240 255',
		'--information-500': '72 102 255',
		'--information-600': '62 77 237',
		'--information-700': '34 47 191',
		'--information-800': '27 43 133',
		'--information-900': '21 22 34',

		'--lo-warning-100': '255 227 150',
		'--lo-warning-200': '251 191 36',
		'--lo-warning-300': '229 160 0',
		'--lo-warning-400': '194 133 12',
		'--lo-warning-50': '254 240 200',
		'--lo-warning-500': '147 111 56',
		'--lo-warning-600': '122 89 26',
		'--lo-warning-700': '92 65 10',
		'--lo-warning-800': '59 43 21',
		'--lo-warning-900': '25 23 20',

		'--neutral-100': '225 226 234',
		'--neutral-200': '195 198 213',
		'--neutral-300': '165 170 192',
		'--neutral-400': '135 142 171',
		'--neutral-50': '240 240 244',
		'--neutral-500': '105 114 150',
		'--neutral-600': '84 91 120',
		'--neutral-700': '63 68 90',
		'--neutral-800': '42 45 60',
		'--neutral-900': '21 22 30',

		'--primary-100': '231 242 245',
		'--primary-150': '225 243 248',
		'--primary-200': '195 235 250',
		'--primary-25': '245 251 255',
		'--primary-300': '151 212 234',
		'--primary-400': '130 180 201',
		'--primary-50': '240 246 250',
		'--primary-500': '40 160 203',
		'--primary-600': '13 126 162',
		'--primary-700': '45 97 125',
		'--primary-800': '34 74 88',
		'--primary-900': '20 51 61',
		'--primary-950': '15 25 28',

		'--secondary-100': '197 238 147',
		'--secondary-200': '152 208 53',
		'--secondary-300': '127 177 53',
		'--secondary-400': '113 159 42',
		'--secondary-50': '221 249 199',
		'--secondary-500': '83 130 0',
		'--secondary-600': '70 108 4',
		'--secondary-700': '47 74 11',
		'--secondary-800': '36 52 19',

		'--success-100': '131 252 212',
		'--success-200': '12 237 166',
		'--success-300': '4 197 133',
		'--success-400': '0 168 113',
		'--success-50': '201 251 235',
		'--success-500': '0 134 89',
		'--success-600': '20 105 71',
		'--success-700': '12 78 41',
		'--success-800': '13 53 30',
		'--success-900': '13 26 18',

		'--tertiary-100': '196 238 235',
		'--tertiary-200': '155 212 207',
		'--tertiary-300': '111 186 179',
		'--tertiary-400': '79 158 153',
		'--tertiary-50': '224 247 246',
		'--tertiary-500': '64 128 126',
		'--tertiary-600': '55 100 98',
		'--tertiary-700': '42 75 69',
		'--tertiary-800': '32 49 49'
	},

	'zoo':{
		//
		'--accent-100': '237 227 255',
		'--accent-200': '213 191 255',
		'--accent-300': '195 157 235',
		'--accent-400': '173 121 233',
		'--accent-450': '130 63 206',
		'--accent-50': '247 242 255',
		'--accent-500': '147 85 220',
		'--accent-600': '120 60 185',
		'--accent-700': '84 39 143',
		'--accent-800': '57 33 94',

		'--error-100': '251 224 208',
		'--error-200': '253 184 174',
		'--error-300': '255 141 123',
		'--error-400': '251 90 71',
		'--error-50': '255 243 242',
		'--error-500': '229 34 7',
		'--error-600': '181 9 9',
		'--error-700': '139 10 3',
		'--error-800': '92 17 17',
		'--error-900': '27 22 22',

		'--foundations-black': '0 0 0',
		'--foundations-white': '255 255 255',

		'--grayscale-100': '240 240 240',
		'--grayscale-200': '230 230 230',
		'--grayscale-300': '201 201 201',
		'--grayscale-400': '173 173 173',
		'--grayscale-50': '243 243 243',
		'--grayscale-500': '145 145 145',
		'--grayscale-600': '117 117 117',
		'--grayscale-700': '92 92 92',
		'--grayscale-800': '69 69 69',
		'--grayscale-900': '46 46 46',

		'--hi-warning-100': '255 226 209',
		'--hi-warning-200': '251 186 167',
		'--hi-warning-300': '252 144 109',
		'--hi-warning-400': '239 94 37',
		'--hi-warning-50': '253 236 221',
		'--hi-warning-500': '207 73 0',
		'--hi-warning-600': '167 47 16',
		'--hi-warning-700': '120 35 18',
		'--hi-warning-800': '61 35 29',
		'--hi-warning-900': '28 22 21',

		'--information-100': '222 229 255',
		'--information-200': '184 200 255',
		'--information-300': '148 173 255',
		'--information-400': '98 142 244',
		'--information-50': '237 240 255',
		'--information-500': '72 102 255',
		'--information-600': '62 77 237',
		'--information-700': '34 47 191',
		'--information-800': '27 43 133',
		'--information-900': '21 22 34',

		'--lo-warning-100': '255 227 150',
		'--lo-warning-200': '251 191 36',
		'--lo-warning-300': '229 160 0',
		'--lo-warning-400': '194 133 12',
		'--lo-warning-50': '254 240 200',
		'--lo-warning-500': '147 111 56',
		'--lo-warning-600': '122 89 26',
		'--lo-warning-700': '92 65 10',
		'--lo-warning-800': '59 43 21',
		'--lo-warning-900': '25 23 20',

		'--neutral-100': '225 226 234',
		'--neutral-200': '195 198 213',
		'--neutral-300': '165 170 192',
		'--neutral-400': '135 142 171',
		'--neutral-50': '240 240 244',
		'--neutral-500': '105 114 150',
		'--neutral-600': '84 91 120',
		'--neutral-700': '63 68 90',
		'--neutral-800': '42 45 60',
		'--neutral-900': '21 22 30',

		'--primary-100': '231 242 245',
		'--primary-150': '225 243 248',
		'--primary-200': '195 235 250',
		'--primary-25': '245 251 255',
		'--primary-300': '151 212 234',
		'--primary-400': '130 180 201',
		'--primary-50': '240 246 250',
		'--primary-500': '40 160 203',
		'--primary-600': '13 126 162',
		'--primary-700': '45 97 125',
		'--primary-800': '34 74 88',
		'--primary-900': '20 51 61',
		'--primary-950': '15 25 28',

		'--secondary-100': '197 238 147',
		'--secondary-200': '152 208 53',
		'--secondary-300': '127 177 53',
		'--secondary-400': '113 159 42',
		'--secondary-50': '221 249 199',
		'--secondary-500': '83 130 0',
		'--secondary-600': '70 108 4',
		'--secondary-700': '47 74 11',
		'--secondary-800': '36 52 19',

		'--success-100': '131 252 212',
		'--success-200': '12 237 166',
		'--success-300': '4 197 133',
		'--success-400': '0 168 113',
		'--success-50': '201 251 235',
		'--success-500': '0 134 89',
		'--success-600': '20 105 71',
		'--success-700': '12 78 41',
		'--success-800': '13 53 30',
		'--success-900': '13 26 18',

		'--tertiary-100': '196 238 235',
		'--tertiary-200': '155 212 207',
		'--tertiary-300': '111 186 179',
		'--tertiary-400': '79 158 153',
		'--tertiary-50': '224 247 246',
		'--tertiary-500': '64 128 126',
		'--tertiary-600': '55 100 98',
		'--tertiary-700': '42 75 69',
		'--tertiary-800': '32 49 49'
	},


	/**
	 * Changes the site theme based on the hostname.
	 */
	applyTheme: ()=>{
		const hostname = window.location.hostname;
		const theme_name = themes.themeMap[hostname];

		//Set theme to comagine by default if hostname doesn't match
		let theme = { ...themes['comagine'], ...themes['static'] } ;

		//If theme found, then overwrite
		if (themes[theme_name])
		{
			theme = { ...theme, ...themes[theme_name] };
		}


		const root = document.documentElement; // Get the <html> element

		// Loop over the theme's properties and set them as CSS variables
		for (const [property, value] of Object.entries(theme)) {
			root.style.setProperty(property, value);
		}
	}
}